import { FileText, Mic, Share2, Video, type LucideIcon } from 'lucide-react';
import { ContentChannel } from '@mg/shared';
import { BLOG_EXPORT_DESTINATION } from '@mg/shared';

/**
 * Post-type ("channel") filter order for the Posts hub (All Posts and Calendar).
 *
 * No Podcast: it is off the product roadmap, so neither view offers it as a filter. The channel itself
 * stays (the composer still opens older podcast posts — see RETIRED_CHANNELS in ContentComposer), and
 * those posts still list under "All".
 */
export const POST_TYPE_ORDER: ContentChannel[] = [
  ContentChannel.BLOG,
  ContentChannel.SOCIAL,
  ContentChannel.VIDEO,
];

/** One lucide glyph per post type, used on the filter chips and post cards. */
export const postTypeIcon: Record<ContentChannel, LucideIcon> = {
  [ContentChannel.BLOG]: FileText,
  [ContentChannel.SOCIAL]: Share2,
  [ContentChannel.VIDEO]: Video,
  [ContentChannel.PODCAST]: Mic,
};

/**
 * Destination options for the non-social channels. Social destinations come from
 * the connected accounts (see `PLATFORM_META`); these are free-label targets that
 * populate the dependent "Platform" filter row. PODCAST no longer has a filter row
 * (see `POST_TYPE_ORDER`); it stays for the composer's older podcast posts.
 */
export const NON_SOCIAL_PLATFORMS: Record<'BLOG' | 'VIDEO' | 'PODCAST', string[]> = {
  // Export first, so a new blog post defaults to producing a file rather than naming a CMS nobody
  // has connected — there is no live-CMS integration in this product; every other entry is a label.
  BLOG: [BLOG_EXPORT_DESTINATION, 'WordPress', 'Medium', 'Webflow', 'Ghost', 'Other'],
  VIDEO: ['YouTube', 'Vimeo', 'TikTok'],
  PODCAST: ['Spotify', 'Apple Podcasts', 'Buzzsprout', 'Other'],
};
